<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// 解决方案
const props = defineProps({
  footer: {
    type: Object,
    default: () => ({ webname: "盒子云" }),
  },
})

const solution = reactive([
  { id: 1, name: t('index.solution3') },
  { id: 2, name: t('index.solution4') },
  { id: 3, name: t('index.solution5') },
  { id: 4, name: t('index.solution6') },
  { id: 5, name: t('index.solution7') },
])

const classCentre = ref(1)
</script>

<template>
  <div class="Heziyun-solution" id="Heziyun-solution">
    <div class="Heziyun-commodity-title">
      <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('index.solution1') }}</span>
      <p v-intersect="{ class: 'bottom-top', delay: 100 }">
        {{ $t('index.solution2') }}
      </p>
    </div>
    <div class="Heziyun-defaultWidth">
      <div class="Heziyun-programme">
        <div
          class="Heziyun-tabar"
          v-intersect="{ class: 'bottom-top', delay: 100 }"
        >
          <div
            class="Heziyun-item"
            v-for="(item, index) in solution"
            :key="item.id"
            @mouseenter="classCentre = index + 1"
            @click="classCentre = index + 1"
            :class="{ 'Heziyun-item-active': classCentre == index + 1 }"
            :style="{
              borderRadius:
                index == 0
                  ? '0.5rem 0 0 0.5rem'
                  : index == solution.length - 1
                  ? '0 0.5rem 0.5rem 0'
                  : '0',
            }"
          >
            <i>{{ "0" + (index + 1) }}</i>
            <span>{{ item.name }}</span>
          </div>
        </div>

        <div
          class="Heziyun-tabarContent"
          v-intersect="{ class: 'bottom-top', delay: 100 }"
        >
          <div class="Heziyun-tabarItem" v-show="classCentre == 1">
            <div class="Heziyun-notebook">
              <div class="laptop">
                <div class="screen">
                  <div class="header"></div>
                  <img src="@/static/img/index/notebook1.webp" alt="" />
                </div>
                <div class="keyboard"></div>
              </div>
            </div>

            <div class="Heziyun-introduce">
              <div class="Heziyun-title">{{ $t('index.solution8') }}</div>
              <div class="Heziyun-miao">
                {{ $t('index.solution9') }}
              </div>
              <div class="Heziyun-satisfactionLevel">
                <div>
                  <span>{{ $t('index.solution10_1')}}</span>
                  <p>{{ $t('index.solution10') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution11_2')}}</span>
                  <p>{{ $t('index.solution11') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution12_3')}}</span>
                  <p>{{ $t('index.solution12') }}</p>
                </div>
              </div>
              <a href="/website.html">{{ $t('index.goImmediately') }}</a>
            </div>
          </div>

          <div class="Heziyun-tabarItem" v-show="classCentre == 2">
            <div class="Heziyun-notebook">
              <div class="laptop">
                <div class="screen">
                  <div class="header"></div>
                  <img src="@/static/img/index/notebook2.webp" alt="" />
                </div>
                <div class="keyboard"></div>
              </div>
            </div>

            <div class="Heziyun-introduce">
              <div class="Heziyun-title">{{ $t('index.solution4') }}</div>
              <div class="Heziyun-miao">
                {{ $t('index.solution13') }}
              </div>
              <div class="Heziyun-satisfactionLevel">
                <div>
                  <span>{{ $t('index.solution10_1')}}</span>
                  <p>{{ $t('index.solution10') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution11_2')}}</span>
                  <p>{{ $t('index.solution11') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution12_3')}}</span>
                  <p>{{ $t('index.solution12') }}</p>
                </div>
              </div>
              <a href="/gamePlan.html">{{ $t('index.goImmediately') }}</a>
            </div>
          </div>

          <div class="Heziyun-tabarItem" v-show="classCentre == 3">
            <div class="Heziyun-notebook">
              <div class="laptop">
                <div class="screen">
                  <div class="header"></div>
                  <img src="@/static/img/index/notebook3.webp" alt="" />
                </div>
                <div class="keyboard"></div>
              </div>
            </div>

            <div class="Heziyun-introduce">
              <div class="Heziyun-title">{{ $t('index.solution5') }}</div>
              <div class="Heziyun-miao">
                {{ $t('index.solution14') }}
              </div>
              <div class="Heziyun-satisfactionLevel">
                <div>
                  <span>{{ $t('index.solution10_1')}}</span>
                  <p>{{ $t('index.solution10') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution11_2')}}</span>
                  <p>{{ $t('index.solution11') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution12_3')}}</span>
                  <p>{{ $t('index.solution12') }}</p>
                </div>
              </div>
              <a href="/mobile.html">{{ $t('index.goImmediately') }}</a>
            </div>
          </div>

          <div class="Heziyun-tabarItem" v-show="classCentre == 4">
            <div class="Heziyun-notebook">
              <div class="laptop">
                <div class="screen">
                  <div class="header"></div>
                  <img src="@/static/img/index/notebook4.webp" alt="" />
                </div>
                <div class="keyboard"></div>
              </div>
            </div>

            <div class="Heziyun-introduce">
              <div class="Heziyun-title">{{ $t('index.solution6') }}</div>
              <div class="Heziyun-miao">
                {{ $t('index.solution15') }}
              </div>
              <div class="Heziyun-satisfactionLevel">
                <div>
                  <span>{{ $t('index.solution10_1')}}</span>
                  <p>{{ $t('index.solution10') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution11_2')}}</span>
                  <p>{{ $t('index.solution11') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution12_3')}}</span>
                  <p>{{ $t('index.solution12') }}</p>
                </div>
              </div>
              <a href="/finance.html">{{ $t('index.goImmediately') }}</a>
            </div>
          </div>

          <div class="Heziyun-tabarItem" v-show="classCentre == 5">
            <div class="Heziyun-notebook">
              <div class="laptop">
                <div class="screen">
                  <div class="header"></div>
                  <img src="@/static/img/index/notebook5.webp" alt="" />
                </div>
                <div class="keyboard"></div>
              </div>
            </div>

            <div class="Heziyun-introduce">
              <div class="Heziyun-title">{{ $t('index.solution7') }}</div>
              <div class="Heziyun-miao">
                {{ $t('index.solution16') }}
              </div>
              <div class="Heziyun-satisfactionLevel">
                <div>
                  <span>{{ $t('index.solution10_1')}}</span>
                  <p>{{ $t('index.solution10') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution11_2')}}</span>
                  <p>{{ $t('index.solution11') }}</p>
                </div>
                <div>
                  <span>{{ $t('index.solution12_3')}}</span>
                  <p>{{ $t('index.solution12') }}</p>
                </div>
              </div>
              <a href="/ecommerce.html">{{ $t('index.goImmediately') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
// 解决方案
.Heziyun-solution {
  .Heziyun-commodity-title {
    background: url("@/static//img/index/backgroundimage.png") no-repeat center;
    background-size: cover;
    position: relative;
    padding: 3rem 0 2rem 0;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgb(32 38 48 / 76%);
    }

    span {
      color: #fff;
      position: relative;
      z-index: 1;
    }

    p {
      color: #666666;
      position: relative;
      z-index: 1;
    }
  }

  .Heziyun-defaultWidth {
    background-color: rgb(32, 38, 48);
    width: 100%;
    padding: 0 0 5rem 0;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url("@/static//img/index/backgroundimage2.png") no-repeat
        center;
      background-size: cover;
      opacity: 0.2;
      filter: brightness(0.5);
    }

    .Heziyun-programme {
      position: relative;
      z-index: 1;
      width: 80rem;
      margin: 0 auto;

      .Heziyun-tabar {
        background-color: #fff;
        border-radius: 0.5rem;
        -webkit-border-radius: 0.5rem;
        -moz-border-radius: 0.5rem;
        -ms-border-radius: 0.5rem;
        -o-border-radius: 0.5rem;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        position: relative;
        top: -1.7rem;

        .Heziyun-item {
          padding: 0.4rem 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          cursor: pointer;
          color: #666666;
          font-size: 1rem;
          font-family: "思源黑";
          position: relative;

          &:hover {
            span {
              transform: translateX(5px);
              -webkit-transform: translateX(5px);
              -moz-transform: translateX(5px);
              -ms-transform: translateX(5px);
              -o-transform: translateX(5px);
            }
          }

          i {
            font-style: normal;
            font-family: "YouShe";
            color: #0746ff;
            font-size: 2rem;
          }
        }

        .Heziyun-item-active {
          color: #fff;
          background-color: #3269ff;
          filter: drop-shadow(0px 0px 4px #3269ff);

          &::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -0.5rem;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 0.5rem solid transparent;
            border-right: 0.5rem solid transparent;
            border-top: 0.5rem solid #3269ff;
          }

          span {
            transform: translateX(5px);
            -webkit-transform: translateX(5px);
            -moz-transform: translateX(5px);
            -ms-transform: translateX(5px);
            -o-transform: translateX(5px);
          }

          i {
            font-style: normal;
            font-family: "YouShe";
            color: #fff;
            font-size: 2rem;
          }
        }
      }

      .Heziyun-tabarContent {
        padding-top: 3rem;

        @keyframes flipCover {
          0% {
            transform: perspective(1900px) rotateX(-88.5deg);
          }

          100% {
            transform: perspective(1000px) rotateX(0deg);
          }
        }

        .laptop {
          display: flex;
          flex-direction: column;
          align-items: center;

          .screen {
            border-radius: 20px;
            box-shadow: inset 0 0 0 2px #c8cacb, inset 0 0 0 10px #000;
            height: 318px;
            width: 518px;
            margin: 0 auto;
            padding: 9px 9px 23px 9px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: linear-gradient(
              15deg,
              #3f51b1 0%,
              #5a55ae 13%,
              #7b5fac 25%,
              #8f6aae 38%,
              #a86aa4 50%,
              #cc6b8e 62%,
              #f18271 75%,
              #f3a469 87%,
              #f7c978 100%
            );
            transform-style: preserve-3d;
            transform: perspective(1900px) rotateX(-88.5deg);
            transform-origin: 50% 100%;
            animation: flipCover 3s forwards;

            &::after {
              background: linear-gradient(to bottom, #272727, #0d0d0d);
              border-radius: 0 0 20px 20px;
              bottom: 2px;
              content: "";
              height: 24px;
              left: 2px;
              position: absolute;
              width: 514px;
            }

            .header {
              width: 100px;
              height: 12px;
              position: absolute;
              background-color: #000;
              top: 9px;
              left: 50%;
              transform: translate(-50%, -0%);
              border-radius: 0 0 6px 6px;
            }
          }

          .keyboard {
            background: radial-gradient(
              circle at center,
              #e2e3e4 85%,
              #a9abac 100%
            );
            border: solid #a0a3a7;
            border-radius: 2px 2px 12px 12px;
            border-width: 1px 2px 0 2px;
            box-shadow: inset 0 -2px 8px 0 #6c7074;
            height: 24px;
            margin-top: -10px;
            position: relative;
            width: 620px;
            z-index: 9;

            &::after {
              background: #e2e3e4;
              border-radius: 0 0 10px 10px;
              box-shadow: inset 0 0 4px 2px #babdbf;
              content: "";
              height: 10px;
              left: 50%;
              margin-left: -60px;
              position: absolute;
              top: 0;
              width: 120px;
            }

            &::before {
              background: 0 0;
              border-radius: 0 0 3px 3px;
              bottom: -2px;
              box-shadow: -270px 0 #272727, 250px 0 #272727;
              content: "";
              height: 2px;
              left: 50%;
              margin-left: -10px;
              position: absolute;
              width: 40px;
            }
          }
        }

        .Heziyun-tabarItem {
          --hzp-motion-from-x: 0;
          --hzp-motion-from-y: var(--hzp-motion-distance);

          display: grid;
          grid-template-columns: repeat(2, 1fr);
          animation: hzp-motion-enter var(--hzp-motion-duration-fast) var(--hzp-motion-ease-out) both;

          .Heziyun-notebook {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 100%;
              height: 100%;
              border-radius: 10px 10px 0 0;
            }
          }

          .Heziyun-introduce {
            display: flex;
            flex-direction: column;
            gap: 2.5rem;
            padding-left: 1rem;

            .Heziyun-title {
              color: #ffffff;
              font-size: 1.3rem;
              position: relative;

              &::before {
                content: "";
                position: absolute;
                width: 2.2rem;
                height: 0.2rem;
                left: 0;
                bottom: -1rem;
                background-color: #3269ff;
              }
            }

            .Heziyun-miao {
              color: #c9c9c9;
              line-height: 2;
              font-size: 0.82rem;
            }

            .Heziyun-satisfactionLevel {
              display: grid;
              grid-template-columns: repeat(3, 1fr);

              div {
                color: #fff;
                display: flex;
                flex-direction: column;
                gap: 0.4rem;

                span {
                  font-size: 1.3rem;
                }

                p {
                  font-size: 0.7rem;
                  color: #c3c3c3;
                }
              }
            }

            a {
              width: max-content;
              border-radius: 0.5rem;
              color: #ffffff;
              font-size: 0.9rem;
              padding: 0.6rem 1.5rem;
              background-color: #007aff;
              font-weight: 400;
              -webkit-border-radius: 0.5rem;
              -moz-border-radius: 0.5rem;
              -ms-border-radius: 0.5rem;
              -o-border-radius: 0.5rem;
              box-shadow: 0px 12px 40px rgba(11, 83, 255, 0.24);

              &:hover {
                opacity: 0.75;
              }
            }
          }
        }
      }
    }
  }
}

// 解决方案
@media (max-width: 768px) {
  .Heziyun-solution {
    padding: 0;

    .Heziyun-commodity-title {
      padding: 5vw 0 1vw 0;
    }

    .Heziyun-defaultWidth {
      padding: 5vw 0;
      font-family: "思源黑";

      .Heziyun-programme {
        width: 100%;

        .Heziyun-tabar {
          background-color: transparent;
          border-radius: none;
          -webkit-border-radius: none;
          -moz-border-radius: none;
          -ms-border-radius: none;
          -o-border-radius: none;
          display: flex;
          align-items: center;
          gap: 3vw;
          position: relative;
          top: -8.5vw;
          overflow-x: auto;
          padding: 0 5vw;

          &::-webkit-scrollbar {
            display: none;
          }

          .Heziyun-item {
            padding: 1vw 3vw;
            gap: 1vw;
            color: #4b5563;
            font-size: 3.5vw;
            background-color: #f3f4f6;
            flex-shrink: 0;
            border-radius: 16vw !important;

            &:hover {
              span {
                transform: translateX(0px);
                -webkit-transform: translateX(0px);
                -moz-transform: translateX(0px);
                -ms-transform: translateX(0px);
                -o-transform: translateX(0px);
              }
            }

            i {
              font-size: 4vw;
            }
          }

          .Heziyun-item-active {
            color: #fff;
            background-color: #3269ff;
            filter: drop-shadow(0px 0px 4px #3269ff);

            &::after {
              display: none;
            }

            span {
              transform: translateX(0px);
              -webkit-transform: translateX(0px);
              -moz-transform: translateX(0px);
              -ms-transform: translateX(0px);
              -o-transform: translateX(0px);
            }

            i {
              font-size: 4vw;
            }
          }
        }

        .Heziyun-tabarContent {
          padding-top: 0;
          padding: 0 5vw;

          .laptop {
            .screen {
              height: 55vw;
              width: 80vw;

              &::before {
                content: none;
              }

              &::after {
                content: "";
                width: 98%;
                height: 20px;
              }

              .header {
                width: 100px;
                height: 10px;
                position: absolute;
                background-color: #000;
                top: 9px;
                left: 50%;
                transform: translate(-50%, -0%);
                border-radius: 0 0 6px 6px;
              }
            }

            .keyboard {
              height: 12px;
              width: 90vw;

              &::after {
                background: #e2e3e4;
                border-radius: 0 0 10px 10px;
                box-shadow: inset 0 0 4px 2px #babdbf;
                content: "";
                height: 10px;
                left: 50%;
                margin-left: -60px;
                position: absolute;
                top: 0;
                width: 120px;
              }

              &::before {
                background: 0 0;
                border-radius: 0 0 3px 3px;
                bottom: -2px;
                box-shadow: -270px 0 #272727, 250px 0 #272727;
                content: "";
                height: 2px;
                left: 50%;
                margin-left: -10px;
                position: absolute;
                width: 40px;
              }
            }
          }

          .Heziyun-tabarItem {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 3vw;

            .Heziyun-notebook {
              position: relative;
            }

            .Heziyun-introduce {
              gap: 5vw;
              padding-left: 0;

              .Heziyun-title {
                font-size: 4.5vw;

                &::before {
                  content: "";
                  position: absolute;
                  width: 10vw;
                  height: 0.8vw;
                  left: 0;
                  bottom: -3vw;
                  background-color: #3269ff;
                }
              }

              .Heziyun-miao {
                font-size: 3.5vw;
              }

              .Heziyun-satisfactionLevel {
                div {
                  gap: 1vw;

                  span {
                    font-size: 4vw;
                  }

                  p {
                    font-size: 3vw;
                  }
                }
              }

              a {
                border-radius: 1vw;
                font-size: 3.5vw;
                padding: 1.5vw 4vw;
                -webkit-border-radius: 1vw;
                -moz-border-radius: 1vw;
                -ms-border-radius: 1vw;
                -o-border-radius: 1vw;
              }
            }
          }
        }
      }
    }
  }
}
</style>
